import React from 'react';
import { AlertTriangle, CheckCircle2 } from '@/components/icons';
import { cn } from '@/lib/utils';

const OPTIONS = [
  {
    value: 'compliant',
    label: 'Conforme',
    icon: CheckCircle2,
    selected: 'border-green-300 bg-green-50 text-green-800',
  },
  {
    value: 'non_compliant',
    label: 'Non conforme',
    icon: AlertTriangle,
    selected: 'border-red-300 bg-red-50 text-red-800',
  },
];

export default function ReceiptStatusSelector({ value = '', onChange, className, compact = false }) {
  return <div className={cn('grid grid-cols-1 sm:grid-cols-2 gap-2', className)} role="radiogroup" aria-label="Esito ricevimento">
    {OPTIONS.map(option => {
      const Icon = option.icon;
      const active = value === option.value;
      return <button
        key={option.value}
        type="button"
        role="radio"
        aria-checked={active}
        onClick={() => onChange?.(option.value)}
        className={cn(
          compact
            ? 'min-h-11 md:min-h-10 rounded-lg border px-2 py-1.5 text-xs font-semibold inline-flex items-center justify-center gap-1.5 transition-colors'
            : 'min-h-12 md:min-h-14 xl:min-h-12 rounded-lg border px-3 py-2 text-sm font-semibold inline-flex items-center justify-center gap-2 transition-colors',
          active ? option.selected : 'border-slate-200 bg-white text-slate-700 hover:bg-slate-50 hover:border-slate-300'
        )}
      >
        <Icon className="h-4 w-4 shrink-0"/>{option.label}
      </button>;
    })}
  </div>;
}
